import clsx from 'clsx';
import React, { isValidElement } from 'react';

type IconProps = {
    size?: number;
    className?: string;
};

type IconComponent = React.ComponentType<IconProps>;

export type IconDefinition = IconComponent | React.ReactNode;

/**
 * Render an icon.
 */
export function renderIcon(icon: IconDefinition, props?: IconProps) {
    if (typeof icon === 'function') {
        const Icon = icon;
        return <Icon {...props} />;
    }
    if (isValidElement<IconProps>(icon)) {
        return React.cloneElement(icon, {
            className: clsx(icon.props.className, props?.className),
            size: icon.props.size ?? props?.size,
        });
    }
    return null;
}
